import template from './SimpleActionCardView.html';
import './SimpleActionCard.scss';
class SimpleActionCardController {
    constructor() { }
}
export const SimpleActionCardComponent = {
    template,
    controller: SimpleActionCardController,
    controllerAs: '$ctrl',
    bindings: {
        label: '@',
        icon: '@',
        size: '@',
        variant: '@',
        chipTag: '@?',
    },
};
